import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import _ from 'lodash';
import {
  fetchStaff,
  setStaff,
  deleteStaff,
  setStaffForm,
} from '../../../store/modules/staff';
import { deleteFile } from '../../../store/modules/file';

import Staff from '../components/Staff';

const mapActionCreators = {
  fetchStaff,
  setStaff,
  deleteStaff,
  setStaffForm,
  deleteFile,
  push,
};

const mapStateToProps = state => ({
  staff: state.staff.staffs[state.staff.current],
  formOpen: state.staff.formOpen,
  staffCount: Object.keys(
    _.filter(state.staff.staffs, o => o.deleted_at === null),
  ).length,
  activities: _.filter(
    _.pick(
      state.activity.activities,
      state.staff.staffs[state.staff.current]
        ? state.staff.staffs[state.staff.current].activities
        : null,
    ),
    ['deleted_at', null],
  ),
  activitiesAsParticipant: _.filter(
    _.pick(
      state.activity.activities,
      state.staff.staffs[state.staff.current]
        ? state.staff.staffs[state.staff.current].activitiesAsParticipant
        : null,
    ),
    ['deleted_at', null],
  ),
  projects: _.filter(
    _.pick(
      state.project.projects,
      state.staff.staffs[state.staff.current]
        ? state.staff.staffs[state.staff.current].projects
        : null,
    ),
    ['deleted_at', null],
  ),
  files: _.filter(
    _.pick(
      state.file.files,
      state.staff.staffs[state.staff.current]
        ? state.staff.staffs[state.staff.current].files
        : null,
    ),
    ['deleted_at', null],
  ),
  tasks: _.filter(
    _.pick(
      state.task.tasks,
      state.staff.staffs[state.staff.current] &&
        state.staff.staffs[state.staff.current].tasks
        ? state.staff.staffs[state.staff.current].tasks.assigned
        : null,
    ),
    ['deleted_at', null],
  ),
  staffs: _.filter(state.staff.staffs, ['deleted_at', null]),
  fetching: state.staff.fetching,
});

export default connect(mapStateToProps, mapActionCreators)(Staff);



// WEBPACK FOOTER //
// ./src/routes/StaffDetail/containers/StaffContainer.js